import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// Components
import HomePage from "./components/HomePage";
import Topbar from "./components/Topbar";
import MainComponent from "./components/MainComponent";
import Footer from "./components/Footer";
import Error from "./components/Error";

function App() {
  return (
    <div className="App">
      <Router>
        <Topbar />
        <Switch>
          <Route path="/" exact>
            <HomePage />
          </Route>
          <Route path="/html" exact>
            <MainComponent subject="html" />
          </Route>
          <Route path="/html/:article">
            <MainComponent subject="html" />
          </Route>
          <Route path="*">
<Error/>
          </Route>
        </Switch>
        <Footer></Footer>
      </Router>
    </div>
  );
}

export default App;
